
<div class="modal-dialog modal-dialog-centered" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <p class="modal-title">
        <i class="fas fa-tag mr-2"></i>
        <span class="font-weight-bold" v-if="isNew">Add RepCode</span>
        <span class="font-weight-bold" v-else>Edit RepCode Name — <span v-text="repcode.label"></span></span>
      </p>
      <button type="button" class="close" v-on:click="close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <small class="form-text text-muted mb-3" v-if="isNew">
        These billing values become the first-choice default when a contract is created for a household whose accounts share this RepCode.
      </small>
      <small class="form-text text-muted mb-3" v-else>
        Update the optional name to help identify this RepCode.
      </small>
      <div class="alert alert-info" role="alert" v-if="!isNew">
        <i class="fas fa-info-circle mr-2"></i>
        <strong>Billing defaults are read-only.</strong> Contact SmartKX support to modify billing settings.
      </div>
      <div class="form-group" v-if="isNew">
        <label>RepCode</label>
        <input
          type="text"
          class="form-control form-control-sm"
          placeholder="e.g. ABC123"
          v-model="form.code"
          :disabled="form.pending"
        />
      </div>
      <div class="form-group">
        <label>Name <small class="text-muted">(optional)</small></label>
        <input
          type="text"
          class="form-control form-control-sm"
          placeholder="e.g. John Smith"
          v-model="form.name"
          :disabled="form.pending"
        />
      </div>
      <div class="form-group" v-if="isNew">
        <label>Default Billing</label>
        <select v-model="form.value" class="form-control form-control-sm" :disabled="!isNew">
          <option v-for="(o, i) in options" :key="i" :value="o.value">{{ o.label }}</option>
        </select>
      </div>
      <div class="form-group" v-else>
        <label>Billing Defaults</label>
        <div class="form-control form-control-sm" style="background-color: #f5f5f5; cursor: default;">
          {{ getBillingDisplay(repcode.billing) }}
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-sm btn-secondary" v-on:click="close">{{ isNew ? 'Cancel' : 'Close' }}</button>
      <button type="button" class="btn btn-sm btn-primary" v-on:click="save" :disabled="form.pending" v-if="isNew">Save RepCode</button>
      <button type="button" class="btn btn-sm btn-primary" v-on:click="save" :disabled="form.pending" v-else>Save Name</button>
    </div>
  </div>
</div>
